
import {Link, useParams} from "react-router-dom";

import {useApiSearchTeacherStudents} from "@/api/userAcademy";

import React, {useEffect, useState} from 'react';
import {CheckCircle, Clock, FileCheck, ListCheck, Save, XCircle} from 'lucide-react';
import TeacherLayout from "@/components/layout/teacher/teacherLayout";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import SearchInputRaw from "@/components/search/SearchInputRaw";
import PaginationRaw from "@/components/pagination/PaginationRaw";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {Alert, Button, Radio, Select} from "antd";
import {weekdayNames} from "@/pages/student/lessons/take/_section/LessonCard";
import {
    useApiGetTeacherLessonSessionDetail,
    useApiPutTeacherLessonAttendance,
    useApiSearchTeacherLessonTimes
} from "@/api/absence";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import RenderLoading from "@/components/render-if-loading";
import RenderIf from "@/components/render-if";
import {useApiReadTeacherLessonDetail} from "@/api/lesson";
import {useApiCreateTeacherReportsModerator, useApiReadTeacherReportsModerator} from "@/api/teacherReports";


function TeacherAttendanceListPage() {
    const {id} = useParams();
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [selectedSession, setSelectedSession] = useState('');
    const [statusOfClass, setStatusOfClass] = useState('');
    const [allowAttendance, setAllowAttendance] = useState(true);

    const [timeId, setTimeId] = useState({});
    const [records, setRecords] = useState({});

    const statusConfig = {
        all: {
            label: 'همه',
            color: 'bg-gray-100 text-gray-700 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700',
            icon: React.createElement(ListCheck, {}),
            dot: 'bg-gray-500',
            hidden: true,
        },
        present: {
            label: 'حاضر',
            color: 'bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-950/50 dark:text-emerald-300 dark:border-emerald-800',
            icon: React.createElement(CheckCircle, {}),
            dot: 'bg-emerald-500'
        },
        late: {
            label: 'تاخیر',
            color: 'bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-950/50 dark:text-blue-300 dark:border-blue-800',
            icon: React.createElement(Clock, {}),
            dot: 'bg-blue-500'
        },
        excused: {
            label: 'موجه',
            color: 'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950/50 dark:text-amber-300 dark:border-amber-800',
            icon: React.createElement(FileCheck, {}),
            dot: 'bg-amber-500'
        },
        absent: {
            label: 'غایب',
            color: 'bg-red-100 text-red-700 border-red-200 dark:bg-red-950/50 dark:text-red-300 dark:border-red-800',
            icon: React.createElement(XCircle, {}),
            dot: 'bg-red-500'
        },
    };

    const {data, isPending: isPendingLoadLesson} = useApiReadTeacherLessonDetail(id);

    const {data: students, isPending} = useApiSearchTeacherStudents({
        lesson_id: id,
        page: page,
        per_page: perPage,
        search: search
    });

    const {data: sessionsList, isPending: isPendingSessionList} = useApiSearchTeacherLessonTimes({
        lesson_id: id,
    });

    const {data: sessionDetail, isPending: isPendingSessionDetail} = useApiGetTeacherLessonSessionDetail({
        lesson_id: id,
        time_id: timeId?.time_id,
        date: timeId?.date,
        enabled: !!timeId?.time_id
    });

    const {mutate: createModeratorReport, isPending: isPendingModerator} = useApiCreateTeacherReportsModerator();

    const {
        data: getModeratorDetail,
        isPending: isPendingGetModeratorDetail,
        refetch
    } = useApiReadTeacherReportsModerator({
        lesson_id: id,
        date: timeId?.date
    });

    const {mutate: SaveAttendance, isPending: isPendingSave} = useApiPutTeacherLessonAttendance();

    useEffect(() => {
        if (!selectedSession && sessionsList?.data?.data?.length > 0) {
            const endIndex = sessionsList?.data?.data?.length - 1;
            const end = sessionsList?.data?.data?.at(endIndex);

            setSelectedSession(end.id + '-' + end.class_date);
            setTimeId({time_id: end.id, date: end.class_date});
        }
    }, [selectedSession, sessionsList]);

    useEffect(() => {
        let tempRecords = {};
        sessionDetail?.data?.data?.map(function (item) {
            tempRecords[item.id] = item?.absences_with_time_date?.type;
        });
        setRecords(tempRecords);
    }, [sessionDetail?.data?.data]);

    const setStatus = (studentId, status) => {
        setRecords(prev => ({...prev, [studentId]: status}));
    };

    const markAll = (status) => {
        const all = {};
        sessionDetail?.data?.data?.forEach(s => {
            all[s.id] = status;
        });
        setRecords(all);
    };

    function handleSaveModerator() {
        if (!statusOfClass) {
            return;
        }

        let myData = {
            lesson_id: id,
            status: statusOfClass,
            date: timeId?.date,
            time_id: timeId?.time_id,
        };

        createModeratorReport(myData, {
            onSuccess: (r) => {
                ApiHandleSuccessMessage(r);
                refetch();
            },
            onError: (e) => {
                ApiHandleErrorMessage(e);
            }
        });
    }

    function handleSave() {
        let data = [];
        let keys = Object.keys(records);

        keys.forEach(s => {
            data.push({id: s, type: records[s] ?? ''});
        });

        let str = selectedSession;
        let index = str.indexOf("-");
        let time_id = str.substring(0, index);
        let date = str.substring(index + 1);

        SaveAttendance({
            attendance: data,
            lesson_id: id,
            time_id: time_id,
            date: date
        }, {
            onSuccess: (r) => {
                ApiHandleSuccessMessage(r);
            },
            onError: (e) => {
                ApiHandleErrorMessage(e);
            }
        });
    }

    useEffect(() => {
        sessionsList?.data?.data?.forEach((s) => {
            if (parseInt(s.id) === parseInt(timeId?.time_id) && s?.class_date === timeId?.date) {
                setAllowAttendance(s?.allow_attendance);
            }
        });
    }, [timeId?.time_id, timeId?.date, sessionsList]);

    const counts = {
        all: Object.values(records).length,
        present: Object.values(records).filter(s => s === 'present').length,
        absent: Object.values(records).filter(s => s === 'absent').length,
        late: Object.values(records).filter(s => s === 'late').length,
        excused: Object.values(records).filter(s => s === 'excused').length,
    };

    return (
        <TeacherLayout backTo={sprintf(URLS.teacher.lessons.detail, {id: id})} pageTitle={'حضور و غیاب'}>
            <div>
                <div className="flex flex-col xl:flex-row gap-4 mb-2">
                    <div className="flex-1 rounded-2xl border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4 shadow-sm">
                        <div className="flex gap-2 flex-wrap">
                            <div className="text-slate-700 dark:text-gray-200">
                                برای ثبت حضور و غیاب ابتدا تاریخ جلسه را مشخص کنید
                            </div>

                            <RenderLoading loading={isPendingSessionList} skeleton={true}>
                                <Select
                                    className="w-full"
                                    onChange={(r) => {
                                        setSelectedSession(r);
                                        let index = r.indexOf("-");
                                        let time_id = r.substring(0, index);
                                        let date = r.substring(index + 1);
                                        setTimeId({time_id: time_id, date: date});
                                    }}
                                    value={selectedSession}
                                    options={sessionsList?.data?.data?.map((s) => ({
                                        value: s.id + '-' + s.class_date,
                                        label: (
                                            <div className="flex gap-1 text-slate-700 dark:text-gray-200">
                                                <span className="hidden md:flex">
                                                    {' جلسه ' + s.session_number + '  '}
                                                </span>
                                                <span>{weekdayNames[s.weekday]}</span>
                                                <span><b>{convertToJalaliWithFormat(s.class_date)}</b></span>
                                                <span className="hidden md:flex">{' ساعت ' + s.start + '-' + s.end}</span>
                                                {s?.allow_attendance && (
                                                    <span className="text-emerald-600 dark:text-emerald-400">
                                                        (آماده ثبت حضور و غیاب)
                                                    </span>
                                                )}
                                            </div>
                                        )
                                    }))}
                                    popupClassName="dark-select-popup"
                                />
                            </RenderLoading>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
                        <RenderLoading loading={isPendingSessionDetail} spin={true}>
                            {Object.keys(statusConfig).map(status => {
                                const cfg = statusConfig[status];
                                return (
                                    <div
                                        key={status}
                                        className={`flex flex-col items-center px-4 py-3 rounded-2xl border text-center ${cfg.color}`}
                                    >
                                        <p className="text-2xl font-bold">{counts[status]}</p>
                                        <p className="text-xs mt-0.5">{cfg.label}</p>
                                        <p className="pt-1">{cfg.icon}</p>
                                    </div>
                                );
                            })}
                        </RenderLoading>
                    </div>
                </div>

                <RenderIf condition={data?.data?.data?.moderator}>
                    <RenderIf condition={getModeratorDetail?.data?.data?.id}>
                        <div className="w-full rounded-2xl border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4 shadow-sm mb-2">
                            <Alert
                                type="info"
                                className="w-full dark:bg-blue-950/30 dark:border-blue-800"
                                showIcon={true}
                                message="گزارش شما از نظم و نظافت این کلاس در این تاریخ ثبت شده است"
                                description={getModeratorDetail?.data?.data?.report}
                            />
                        </div>
                    </RenderIf>

                    <RenderLoading loading={isPendingGetModeratorDetail} skeleton={true}>
                        <RenderIf condition={!getModeratorDetail?.data?.data?.id && allowAttendance}>
                            <div className="w-full rounded-2xl border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4 shadow-sm mb-2">
                                <div className="mb-4">
                                    <span className="text-sm text-slate-700 dark:text-gray-300">
                                        این کلاس دارای ناظم است و وظیفه ایشان نگهداری کلاس به صورت تمیز و منظم است.
                                        <br/>
                                        شما می‌توانید گزارش خود را از وضعیت نظم و نظافت کلاس برای کارشناسان آموزش ارسال کنید
                                        <br/>
                                        <span className="font-bold text-slate-900 dark:text-gray-100">
                                            به صورت کلی وضعیت نظم و نظافت محل برگزاری کلاس خود را چگونه توصیف می‌کنید؟
                                        </span>
                                    </span>

                                    <br/>

                                    <div className="text-xl">
                                        <Radio.Group value={statusOfClass} onChange={(e) => setStatusOfClass(e.target.value)}>
                                            <Radio name="report" value="ok" className="text-green-600 dark:text-green-400 font-bold my-4">
                                                نظافت انجام شده
                                            </Radio>
                                            <br/>
                                            <Radio name="report" value="nok" className="text-red-600 dark:text-red-400 font-bold">
                                                نظافت انجام نشده
                                            </Radio>
                                        </Radio.Group>
                                    </div>
                                </div>

                                <div className="flex justify-between w-full">
                                    <div></div>
                                    <div>
                                        <Button
                                            type="primary"
                                            variant="solid"
                                            loading={isPendingModerator}
                                            onClick={handleSaveModerator}
                                        >
                                            ثبت و ارسال گزارش نظافت کلاس
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </RenderIf>
                    </RenderLoading>
                </RenderIf>

                <div className="mb-2">
                    <SearchInputRaw
                        setPage={setPage}
                        setSearch={setSearch}
                        placeHolder="جستجو در لیست افراد این کلاس ..."
                    />
                </div>

                <div className="rounded-2xl shadow-sm border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-900 ">
                    <div className="p-4 border-b border-slate-100 dark:border-gray-800 flex flex-wrap items-center justify-between gap-3">
                        <p className="text-sm font-semibold text-slate-700 dark:text-gray-200">
                            لطفا هر کدام از دانش آموزان که غیبت یا تاخیر دارند را مشخص کنید و در پایان دکمه ذخیره حضور و غیاب را بزنید
                        </p>

                        <div className="flex flex-wrap items-center gap-2">
                            <span className="text-xs text-slate-500 dark:text-gray-400">
                                علامت‌گذاری همه دانش آموزان به عنوان:
                            </span>

                            <div className="flex flex-wrap gap-1">
                                {Object.keys(statusConfig).map(status => (
                                    <button
                                        key={status}
                                        onClick={() => markAll(status)}
                                        className={`px-2.5 py-1.5 rounded-lg text-xs font-medium border transition-all hover:opacity-80 ${statusConfig[status]?.hidden ? 'hidden' : ''} ${statusConfig[status].color}`}
                                    >
                                        {statusConfig[status].label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="divide-y divide-slate-100 dark:divide-gray-800">
                        <RenderLoading loading={isPending} skeleton={true}>
                            {students?.data?.data.map((student, i) => {
                                const current = records[student.id] || 'all';

                                return (
                                    <div
                                        key={student.id + '-student-absence' + i}
                                        className="flex flex-wrap items-center gap-4 px-4 py-4 hover:bg-slate-50 dark:hover:bg-gray-800/70 transition-colors"
                                    >
                                        <img
                                            src={student?.student_detail?.avatar ?? '/images/profile.jpg'}
                                            alt={student?.student_detail?.code}
                                            className="w-9 h-9 rounded-full object-cover flex-shrink-0 ring-1 ring-slate-200 dark:ring-gray-700"
                                        />

                                        <div className="flex-1 min-w-[100px]">
                                            <p className="font-medium text-sm text-slate-800 dark:text-gray-100">
                                                {student?.student_detail?.firstname}{' '}
                                                {student?.student_detail?.lastname}

                                                <span>
                                                    <Link
                                                        to={sprintf(URLS.teacher.lessons.studentsDetail, {
                                                            id: id,
                                                            studentId: student?.student
                                                        })}
                                                        className="text-xs text-slate-500 dark:text-gray-400"
                                                    >
                                                        <Button variant="link" type="link">مشاهده پروفایل</Button>
                                                    </Link>
                                                </span>
                                            </p>

                                            <p className="text-xs text-slate-500 dark:text-gray-400">
                                                {student?.student_detail?.code}
                                            </p>
                                        </div>

                                        <div className="flex flex-wrap gap-1.5">
                                            {Object.keys(statusConfig).map(status => {
                                                const cfg = statusConfig[status];
                                                const isSelected = current === status;

                                                if (cfg?.hidden) {
                                                    return null;
                                                }

                                                return (
                                                    <button
                                                        key={status}
                                                        onClick={() => setStatus(student.id, status)}
                                                        className={`px-3 py-1.5 rounded-xl text-xs font-medium border transition-all ${
                                                            isSelected
                                                                ? `${cfg.color} shadow-sm scale-105`
                                                                : 'bg-slate-50 text-slate-500 border-slate-200 hover:bg-slate-100 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-700'
                                                        }`}
                                                    >
                                                        {cfg.label}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                        </RenderLoading>
                    </div>

                    <PaginationRaw data={students?.data} setPage={setPage} setPerPage={setPerPage}/>

                    <div className="p-4 border-t border-slate-100 dark:border-gray-800 flex flex-wrap items-center justify-between gap-3">
                        <Button
                            loading={isPendingSave}
                            size="large"
                            variant="solid"
                            color="primary"
                            icon={<Save className="w-4 h-4"/>}
                            onClick={handleSave}
                        >
                            ذخیره حضور و غیاب
                        </Button>

                        <RenderIf condition={!allowAttendance}>
                            <div className="text-red-600 dark:text-red-400 text-sm">
                                مهلت ثبت حضور و غیاب برای این تاریخ به پایان رسیده است
                            </div>
                        </RenderIf>
                    </div>
                </div>
            </div>

            <RenderIf condition={data?.data?.data?.moderator}>
                <Alert
                    type="warning"
                    className="my-4 dark:bg-amber-950/30 dark:border-amber-800"
                    showIcon={true}
                    description={
                        <div className="flex justify-between flex-wrap gap-4">
                            <div className="text-slate-700 dark:text-gray-200">
                                لطفا کارشناسان آموزش را از نظم و نظافت محل برگزاری کلاس خود مطلع کنید
                            </div>

                            <div>
                                <Link to={sprintf(URLS.teacher.lessons.moderator, {id: id})}>
                                    <Button color="orange" variant="solid">
                                        ثبت گزارش نظم و نظافت
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    }
                />
            </RenderIf>
        </TeacherLayout>
    );
}

export default TeacherAttendanceListPage;
